<template>
  <div class="card-container">
    <div class="faq-title">
      Perguntas frequentes sobre Coparticipação
      <p>
        Para saber mais detalhes sobre cobrança de coparticipação, entre em
        contato com a sua empresa!
      </p>
    </div>
    <br />

    <div class="hide" id="ancora-faq"></div>

    <div class="voltar-tabela" v-if="isShowButton" @click="subirParaTopo" style="cursor: pointer;">
      <img src="../../assets/images/up-arrow.svg"></img>
      <div class="texto-botao-voltar">Voltar para minha tabela</div>
    </div>

    <a class="card-faq-header" v-b-toggle.collapse-1>
      <div class="card-faq-header-content" @click="
        isShowComoFuncionaCoparticipacao = !isShowComoFuncionaCoparticipacao
        ">
        <div class="card-faq-header-title">
          Como funciona a coparticipação? Todos os planos têm?
        </div>
        <div class="card-faq-header-icon">
          <b-icon icon="chevron-up" v-show="isShowComoFuncionaCoparticipacao"></b-icon>
          <b-icon icon="chevron-down" v-show="!isShowComoFuncionaCoparticipacao"></b-icon>
        </div>
      </div>
    </a>
    <b-collapse id="collapse-1" class="card-faq-texto">
      <b-card class="card-faq-inner-text">
        <p>
          A coparticipação é uma forma de melhorar o custo-benefício do seu
          plano e mantê-lo ideal para suas necessidades de utilização.
        </p>
        <p>
          Em um plano com coparticipação, você terá mensalidades reduzidas e ao
          realizar consultas e procedimentos diversos, fará o pagamento da
          coparticipação.
        </p>
        <p>
          Mas não se preocupe! Os valores e percentuais da coparticipação sempre
          são pré-definidos em contrato e têm um teto máximo que pode ser
          aplicado. Além disso, você não precisa pagar nenhum valor na hora do
          seu atendimento e a coparticipação é cobrada em um boleto separado,
          próximo da mensalidade.
        </p>
      </b-card>
    </b-collapse>

    <a class="card-faq-header" v-b-toggle.collapse-2>
      <div class="card-faq-header-content" @click="isShowCalculoCoparticipacao = !isShowCalculoCoparticipacao">
        <div class="card-faq-header-title">
          Como funciona o cálculo da coparticipação?
        </div>
        <div class="card-faq-header-icon">
          <b-icon icon="chevron-up" v-show="isShowCalculoCoparticipacao"></b-icon>
          <b-icon icon="chevron-down" v-show="!isShowCalculoCoparticipacao"></b-icon>
        </div>
      </div>
    </a>
    <b-collapse id="collapse-2" class="card-faq-texto">
      <b-card class="card-faq-inner-text">
        <p>A Tabela de Coparticipação no site da UGF já apresenta os valores finais calculados com base no percentual do
          seu plano, eliminando a necessidade de contas manuais. Esse valor exibido corresponde a uma única unidade do
          procedimento e pode englobar três componentes (Honorários Médicos, Custo Operacional e Filme), dependendo do
          procedimento. Caso o cálculo de um item de alto custo ultrapasse o limite do seu plano, a cobrança será
          automaticamente fixada no valor do seu teto contratual vigente.</p>
        <p>Fique atento à quantidade e ao local do atendimento: procedimentos realizados múltiplas vezes no mesmo dia
          terão o custo multiplicado pela quantidade executada (como exames feitos em membros distintos). Além disso, em
          atendimentos de urgência ou emergência em Pronto Atendimento, poderá incidir a cobrança de um pacote de
          serviços assistenciais sempre que houver a aplicação de insumos como soro, materiais e medicamentos
          hospitalares.</p>
        <p>A cobrança de internações segue as regras do seu contrato, sendo considerada como tal apenas a permanência em
          leito hospitalar que ultrapasse 24 horas (planos com coparticipação de 0% são isentos). Todos esses valores
          são lançados na fatura e ficam disponíveis para consulta no extrato do portal do beneficiário assim que a
          operadora recebe e processa a conta enviada pelo hospital ou clínica prestadora.</p>
      </b-card>
    </b-collapse>

    <a class="card-faq-header" v-b-toggle.collapse-3 id="header-urgencia">
      <div class="card-faq-header-content">
        <div class="card-faq-header-title">
          Como funciona o Acréscimo de Urgência e Emergência?
        </div>
        <div class="card-faq-header-icon">
          <b-icon icon="chevron-up" v-show="isShowAcrescimoUrgenciaEmergencia"></b-icon>
          <b-icon icon="chevron-down" v-show="!isShowAcrescimoUrgenciaEmergencia"></b-icon>
        </div>
      </div>
    </a>
    <b-collapse id="collapse-3" v-model="isShowAcrescimoUrgenciaEmergencia" class="card-faq-texto">
      <b-card class="card-faq-inner-text">
        <p>
          Seguindo as normas nacionais (CBHPM - Classificação Brasileira Hierarquizada de Procedimentos Médicos),
          atendimentos realizados em horários especiais sofrem um <strong>acréscimo de 30% sobre os honorários
            médicos</strong>. Isso impacta o cálculo final da sua coparticipação.
        </p>
        <p><strong>Quando se aplica?</strong></p>
        <ul>
          <li><strong>Noites</strong>: Entre 19h e 07h.</li>
          <li><strong>Fins de semana e feriados</strong>: Sábados, domingos e feriados.</li>
          <li><strong>Procedimentos mistos</strong>: O acréscimo se aplica se mais da metade do atendimento ocorrer nos
            períodos acima.</li>
        </ul>

        <p><strong>Exemplo prático</strong>: Um procedimento de R$ 100,00 com coparticipação de 50%:</p>
        <ul>
          <li><strong>Horário Normal</strong>: Você paga R$ 50,00.</li>
          <li><strong>Urgência/Feriado</strong>: O valor vai para R$ 130,00 e você paga R$ 65,00.</li>
        </ul>
        <p><strong>Nota Transparência</strong>: A CBHPM é o padrão nacional utilizado pela Agência Nacional de Saúde
          Suplementar (ANS) para classificar e valorizar procedimentos médicos em todo o país.</p>
      </b-card>
    </b-collapse>
  </div>


</template>
<script>
export default {
  props: {
    isShowButton: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowComoFuncionaCoparticipacao: false,
      isShowCalculoCoparticipacao: false,
      isShowAcrescimoUrgenciaEmergencia: false,
    };
  },

  methods: {
    subirParaTopo() {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    abrirSecaoUrgencia() {
      this.isShowAcrescimoUrgenciaEmergencia = true;
      setTimeout(() => {
        const element = document.getElementById("header-urgencia");
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 150);
    },
  }
};
</script>

<style scoped>
.texto-botao-voltar {
  font-size: 14px;
}

.voltar-tabela {
  color: var(--color-brand-primary);
  border: 1px solid var(--color-brand-primary);
  border-radius: 5px;
  display: flex;
  gap: 8px;
  flex-direction: row;
  align-items: center;
  width: 230px;
  padding: 10px 16px;
  font-weight: 600;
  margin-top: 10px;
  margin-bottom: 32px;
}

.voltar-tabela img {
  width: 25px;
}

.card-container {
  padding: 0 0 5% 0;
}

.hide {
  visibility: hidden !important;
}

.faq-title {
  color: var(--color-brand-primary);
  font-family: UnimedSlab-SemiBold;
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
  line-height: 35px;
  margin-left: 15px;
  margin-top: 20px;
  padding-bottom: 15px;
  text-align: center;
}

.faq-title p {
  margin-top: 32px;
  font-size: 14px;
  color: var(--text-primary);
  font-family: UnimedSans-Regular;
  font-weight: 400;
}

.card-faq-header {
  color: var(--faq-header-text);
  text-decoration: none;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15px;
}

.card-faq-header-content {
  cursor: pointer;
  background: var(--bg-surface-secondary) 0% 0% no-repeat padding-box;
  box-shadow: 0px 2px 6px var(--card-shadow);
  border-radius: 6px;
  display: table;
  height: 85px;
  margin: 20px auto;
  opacity: 1;
  text-align: left;
}

.card-faq-header-title {
  font-family: UnimedSans-Regular;
  display: table-cell;
  vertical-align: middle;
  padding-left: 30px;
  padding-right: 50px;
}

.card-faq-header-icon {
  display: table-cell;
  vertical-align: middle;
  width: 60px;
  margin: auto;
  transition: 0.5s transform ease;
}

.card-body {
  padding-top: 0;
  padding-left: 0;
}

.card-faq-inner-text {
  font-family: UnimedSans-Regular;
  padding: 0 28px;
}

.card-faq-texto .card {
  border: none;
  border-radius: 0;
  text-align: left;
  border-bottom: 1px solid var(--border-light);
  margin-bottom: 40px;
}

.mensagem-rodape {
  padding: 50px 0;
}

.slide-enter {
  opacity: 0;
  transform: translateY(-20px);
  transition: 0.5s all ease;
}

.slide-enter-to {
  opacity: 1;
  transform: translateY(0px);
  transition: 0.5s all ease;
}

.slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
  transition: 0.5s all ease;
}

.procedure-detail {
  color: var(--color-brand-primary);
  font-weight: bold
}

#header-urgencia {
  scroll-margin-top: 30px;
}

@media (min-width: 320px) {
  .card-faq-header-content {
    width: 300px;
  }
}

@media (min-width: 480px) {
  .card-faq-header-content {
    width: 440px;
  }
}

@media (min-width: 576px) {
  .card-faq-header-content {
    width: 540px;
  }
}

@media (min-width: 700px) {
  .card-faq-header-content {
    width: 680px;
  }
}

@media (min-width: 992px) {
  .card-faq-header-content {
    width: 920px;
  }
}
</style>
